import uniqBy from 'lodash/uniqBy';
import type { ITrafficSituation } from '../models/traffic-situation.model';
import type { ILine } from '../models/line.model';
import type { IServiceJourney } from '../models/service-journey.model';
import type { TransportMode } from '../models/transport-mode.enum';

export class TrafficSituationHelper {
  public static getDistictLines(ts: ITrafficSituation): ILine[] {
    let result: ILine[] = [];

    if (ts.affectedLines) {
      result = result.concat(ts.affectedLines);
    }

    if (ts.affectedJourneys) {
      result = result.concat(ts.affectedJourneys.map((affectedJourney: IServiceJourney) => affectedJourney.line).filter((line) => line !== undefined) as ILine[]);
    }

    return uniqBy(result, (line) => line.gid);
  }

  public static affectsLineWithTransportMode(ts: ITrafficSituation, tm: TransportMode): boolean {
    return TrafficSituationHelper.getDistictLines(ts).some((l) => l.transportMode === tm);
  }
}
